export default {
      id: "calibrate-usage",
      viewBox: "0 0 14 12",
      url: __webpack_public_path__ + "img/icons.b61b1948.svg#calibrate",
      toString: function () {
        return this.url;
      }
    }